import { ConfigProvider, Table } from 'antd';
import React, { memo } from 'react';
import { ColumnsType } from 'antd/es/table';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import 'components/css/customTableSummary.css';
import { CaretUpOutlined, RightOutlined } from '@ant-design/icons';
import formatNumber from 'utils/formatNumber';

interface IProps {
  tuxman: any[];
  productSelected: any[];
  handleSelectTuXman: (data: any) => void;
  handleSelectChungLoai: (data: any) => void;
}
const TableCapitalProductCartList = (props: IProps) => {
  const { tuxman, productSelected, handleSelectTuXman, handleSelectChungLoai } =
    props;

  tuxman?.forEach((tu) => {
    tu.sl_mau_dang_ky = productSelected.reduce((total, product) => {
      if (product.tu_xman_code === tu.code) {
        return total + 1;
      }
      return total;
    }, 0);
    tu.min_dang_ky = productSelected.reduce((total, product) => {
      if (product.tu_xman_code === tu.code) {
        return total + product.order_min;
      }
      return total;
    }, 0);
    tu.max_dang_ky = productSelected.reduce((total, product) => {
      if (product.tu_xman_code === tu.code) {
        return total + product.order_max;
      }
      return total;
    }, 0);

    tu.von_min_dk = productSelected.reduce((total, product) => {
      if (product.tu_xman_code === tu.code) {
        return total + product.order_min * product.cost_price;
      }
      return total;
    }, 0);

    tu.von_max_dk = productSelected.reduce((total, product) => {
      if (product.tu_xman_code === tu.code) {
        return total + product.order_max * product.cost_price;
      }
      return total;
    }, 0);
  });

  const columns: ColumnsType<any> = [
    {
      title: 'Tủ Xman',
      dataIndex: 'name',
      // fixed: 'left',
      width: 150,
      render(value, record, index) {
        return (
          <div
            style={{ color: '#00538F', fontWeight: 'bold' }}
            className="cursor-pointer"
          >
            <span>
              {value}
              <RightOutlined style={{ marginLeft: 4, fontSize: 12 }} />
            </span>
          </div>
        );
      },
    },
    {
      title: 'Đơn vị tính',
      dataIndex: 'cabinet_type',
      width: 122,
    },
    {
      title: 'Số lượng tủ',
      dataIndex: 'so_luong_tu',
      width: 122,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Số lượng mẫu',
      dataIndex: 'so_luong',
      width: 122,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'SL mẫu kỳ cũ',
      dataIndex: 'sl_mau_ky_cu',
      width: 122,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'SL mẫu đăng ký',
      dataIndex: 'sl_mau_dang_ky',
      width: 150,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'SL mẫu chênh lệch (mới - cũ)',
      dataIndex: 'sl_mau_chenh_lech',
      width: 150,
      render(value, record, index) {
        return formatNumber(
          (record.sl_mau_dang_ky ?? 0) - (record.sl_mau_ky_cu ?? 0)
        );
      },
    },
    {
      title: 'Min kế hoạch',
      dataIndex: 'min_ke_hoach',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Min đăng ký',
      dataIndex: 'min_dang_ky',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Cảnh báo Min - Min kế hoạch',
      dataIndex: 'canh_bao_min',
      width: 150,
      render(value, record, index) {
        return (
          <span
            style={{
              color:
                (record.min_dang_ky ?? 0) - (record.min_ke_hoach ?? 0) < 0
                  ? '#DC362E'
                  : '#FFFFFF',
            }}
          >
            {formatNumber(
              (record.min_dang_ky ?? 0) - (record.min_ke_hoach ?? 0)
            )}
          </span>
        );
      },
    },
    {
      title: 'Max kế hoạch',
      dataIndex: 'max_ke_hoach',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Max đăng ký',
      dataIndex: 'max_dang_ky',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Cảnh báo Max - Max kế hoạch',
      // dataIndex: 'canh_bao_max',
      width: 180,
      render(value, record, index) {
        return (
          <span
            style={{
              color:
                (record.max_dang_ky ?? 0) - (record.max_ke_hoach ?? 0) > 0
                  ? '#DC362E'
                  : '#FFFFFF',
            }}
          >
            {formatNumber(
              (record.max_dang_ky ?? 0) - (record.max_ke_hoach ?? 0)
            )}
          </span>
        );
      },
    },
    {
      title: 'Vốn min đăng ký',
      dataIndex: 'von_min_dk',
      width: 200,
      align: 'right',
      render(value, record, index) {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn max đăng ký',
      dataIndex: 'von_max_dk',
      width: 200,
      align: 'right',
      render(value, record, index) {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn max kế hoạch',
      dataIndex: 'von_max_kh',
      width: 150,
      align: 'right',
      render(value, record, index) {
        return formatNumber(value);
      },
    },
  ];

  const column_chungloai: ColumnsType<any> = [
    {
      title: 'Tủ Xman',
      dataIndex: 'chung_loai_text',
      // fixed: 'left',
      width: 150,
    },
    {
      title: 'Đơn vị tính',
      dataIndex: 'cabinet_type',
      width: 122,
    },
    {
      title: 'Số lượng tủ',
      dataIndex: 'so_luong_tu',
      width: 122,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Số lượng mẫu',
      dataIndex: 'count',
      width: 122,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'SL mẫu kỳ cũ',
      dataIndex: 'sl_mau_ky_cu',
      width: 122,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'SL mẫu đăng ký',
      dataIndex: 'sl_mau_dk_chung_loai',
      width: 150,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'SL mẫu chênh lệch (mới - cũ)',
      dataIndex: 'sl_mau_chenh_lech',
      width: 150,
      render(value, record, index) {
        return formatNumber(
          (record.sl_mau_dang_ky ?? 0) - (record.sl_mau_ky_cu ?? 0)
        );
      },
    },
    {
      title: 'Min kế hoạch',
      dataIndex: 'min_ke_hoach',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Min đăng ký',
      dataIndex: 'min_dang_ky',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Cảnh báo Min - Min kế hoạch',
      dataIndex: 'canh_bao_min',
      width: 150,
      // render(value, record, index) {
      //   return (
      //     <span
      //       style={{
      //         color:
      //           (record.min_dang_ky ?? 0) - (record.min_ke_hoach ?? 0) < 0
      //             ? '#DC362E'
      //             : '#FFFFFF',
      //       }}
      //     >
      //       {formatNumber(
      //         (record.min_dang_ky ?? 0) - (record.min_ke_hoach ?? 0)
      //       )}
      //     </span>
      //   );
      // },
    },
    {
      title: 'Max kế hoạch',
      dataIndex: 'max_ke_hoach',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Max đăng ký',
      dataIndex: 'max_dang_ky',
      width: 120,
      render(value, record, index) {
        return formatNumber(value);
      },
    },
    {
      title: 'Cảnh báo Max - Max kế hoạch',
      dataIndex: 'canh_bao_max',
      width: 180,
      // render(value, record, index) {
      //   return (
      //     <span
      //       style={{
      //         color:
      //           (record.max_dang_ky ?? 0) - (record.max_ke_hoach ?? 0) > 0
      //             ? '#DC362E'
      //             : '#FFFFFF',
      //       }}
      //     >
      //       {formatNumber(
      //         (record.max_dang_ky ?? 0) - (record.max_ke_hoach ?? 0)
      //       )}
      //     </span>
      //   );
      // },
    },
    {
      title: 'Vốn min đăng ký',
      dataIndex: 'von_min_dk',
      width: 200,
      align: 'right',
      render(value, record, index) {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn max đăng ký',
      dataIndex: 'von_max_dk',
      width: 200,
      align: 'right',
      render(value, record, index) {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn max kế hoạch',
      dataIndex: 'von_max_kh',
      width: 150,
      align: 'right',
      render(value, record, index) {
        return formatNumber(value);
      },
    },
  ];

  const calculateColumnTotal = (data: any, key: any) => {
    return data?.reduce((total: any, item: any) => total + (item[key] || 0), 0);
  };

  return (
    <Table
      rowKey={(record) => record.code}
      columns={columns}
      className="customTable"
      dataSource={tuxman}
      scroll={{ x: 1958, y: 350 }}
      size="small"
      onRow={(row) => ({
        onClick: () => {
          handleSelectTuXman(row);
        },
      })}
      pagination={false}
      expandable={{
        expandedRowRender: (record) => {
          record.chung_loai_detail?.forEach((chung_loai: any) => {
            chung_loai.cabinet_type = record.cabinet_type;
            chung_loai.sl_mau_dk_chung_loai = productSelected.reduce(
              (total, product) => {
                if (
                  (product.chung_loai_code === chung_loai.chung_loai_code ||
                    product.chungloai === chung_loai.chung_loai_code) &&
                  product.tu_xman_code === record.code
                ) {
                  return total + 1;
                }
                return total;
              },
              0
            );
            chung_loai.min_dang_ky = productSelected.reduce(
              (total, product) => {
                if (
                  product.chung_loai_code === chung_loai.chung_loai_code &&
                  product.tu_xman_code === record.code
                ) {
                  return total + product.order_min;
                }
                return total;
              },
              0
            );
            chung_loai.max_dang_ky = productSelected.reduce(
              (total, product) => {
                if (
                  product.chung_loai_code === chung_loai.chung_loai_code &&
                  product.tu_xman_code === record.code
                ) {
                  return total + product.order_max;
                }
                return total;
              },
              0
            );
          });
          return (
            // <div style={{ margin: -8 }}>
            <Table
              key={record.chung_loai_code}
              rowKey={(record) => record.chung_loai_code}
              columns={column_chungloai}
              dataSource={record.chung_loai_detail}
              size="small"
              scroll={{ x: 1958 }}
              pagination={false}
              showHeader={false}
              // rowClassName={() => 'custom-expanded-row'}
              onRow={(row) => ({
                onClick: () => {
                  handleSelectTuXman(record);
                  handleSelectChungLoai(row);
                },
              })}
            />
            // </div>
          );
        },
      }}
      summary={() => {
        let totalSoLuongTu = 0;
        let totalSoLuong = 0;
        let totalSoLuongMauKyCu = 0;
        let totalSoLuongMauDK = 0;
        let totalMinKH = 0;
        let totalMinDK = 0;
        let totalMaxKH = 0;
        let totalMaxDK = 0;
        let totalVonMinDK = 0;
        let totalVonMaxDK = 0;
        let totalVonMaxKH = 0;

        tuxman?.forEach(
          ({
            so_luong_tu,
            so_luong,
            sl_mau_ky_cu,
            sl_mau_dang_ky,
            min_ke_hoach,
            min_dang_ky,
            max_ke_hoach,
            max_dang_ky,
            von_min_dk,
            von_max_dk,
            von_max_kh,
          }) => {
            totalSoLuongTu += so_luong_tu ?? 0;
            totalSoLuong += so_luong;
            totalSoLuongMauKyCu += sl_mau_ky_cu ?? 0;
            totalSoLuongMauDK += sl_mau_dang_ky ?? 0;
            totalMinKH += min_ke_hoach;
            totalMinDK += min_dang_ky;
            totalMaxKH += max_ke_hoach;
            totalMaxDK += max_dang_ky;
            totalVonMinDK += von_min_dk ?? 0;
            totalVonMaxDK += von_max_dk ?? 0;
            totalVonMaxKH += von_max_kh ?? 0;
          }
        );

        return (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                <span style={{ fontWeight: 'bold' }}>Tổng</span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalSoLuongTu)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalSoLuong)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalSoLuongMauKyCu)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalSoLuongMauDK)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={7}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalSoLuongMauDK - totalSoLuongMauKyCu)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={8}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMinKH)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={9}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMinDK)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={10}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMinDK - totalMinKH)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={11}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMaxKH)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={12}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMaxDK)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={13}>
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMaxDK - totalMaxKH)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={14} align="right">
                <span style={{ fontWeight: 'bold' }}>
                  {formatCurrencyVND(totalVonMinDK)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={15} align="right">
                <span style={{ fontWeight: 'bold' }}>
                  {formatCurrencyVND(totalVonMaxDK)}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={16} align="right">
                <span style={{ fontWeight: 'bold' }}>
                  {formatCurrencyVND(totalVonMaxKH)}
                </span>
              </Table.Summary.Cell>

              {/* <Table.Summary.Cell index={14}></Table.Summary.Cell> */}
              {/* <Table.Summary.Cell index={15}></Table.Summary.Cell> */}
              {/* <Table.Summary.Cell index={16} align="right">
                <span style={{ fontWeight: 'bold' }}>
                  {formatNumber(totalMaxDK - totalMinDK)}
                </span>
              </Table.Summary.Cell> */}
              {/* <Table.Summary.Cell index={17}></Table.Summary.Cell> */}
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
    />
  );
};

export default memo(TableCapitalProductCartList);
